import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../ParticipantsStore';
import Skeleton from '../Skeleton';
import BodyReady from './BodyReady';

interface Props {
  participantsStore: ParticipantsStore;
}

function Body({ participantsStore }: Props) {
  switch (participantsStore.optionsStore.state.kind) {
    case 'error':
    case 'loading':
    case 'waiting':
      return <Skeleton filterCount={8} tableColCount={8} checkBoxRequirement="required" />;
    case 'ready':
      return (
        <BodyReady
          participantsStore={participantsStore}
          participantsOptionsResource={participantsStore.optionsStore.state.resource}
        />
      );
  }
}
export default observer(Body);
